import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/success-status.svg'
import _imports_1 from '@/app/ui/assets/svg/failed-status.svg'
import _imports_2 from '@/app/ui/assets/svg/partially-status.svg'


const _hoisted_1 = {
  key: 0,
  class: "mr-1",
  src: _imports_0,
  alt: "success"
}
const _hoisted_2 = {
  key: 1,
  class: "mr-1",
  src: _imports_1,
  alt: "failed"
}
const _hoisted_3 = {
  key: 2,
  class: "mr-1",
  src: _imports_2,
  alt: "partial"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_booking_commission_detail_criteria_booking = _resolveComponent("booking-commission-detail-criteria-booking")!
  const _component_booking_commission_detail_commission_rules = _resolveComponent("booking-commission-detail-commission-rules")!
  const _component_booking_commission_detail_tier_calculation = _resolveComponent("booking-commission-detail-tier-calculation")!
  const _component_booking_commission_detail_criteria_booking_file = _resolveComponent("booking-commission-detail-criteria-booking-file")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CreateUpdate = _resolveComponent("CreateUpdate")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "py-4",
    onBack: _ctx.goBack,
    title: _ctx.title,
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.getDetail
  }, {
    data: _withCtx(() => [
      _createVNode(_component_booking_commission_detail_criteria_booking),
      _createVNode(_component_booking_commission_detail_commission_rules),
      _createVNode(_component_booking_commission_detail_tier_calculation),
      _createVNode(_component_booking_commission_detail_criteria_booking_file)
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status" }, {
        default: _withCtx(() => [
          _createVNode("div", {
            class: 
            `capitalize overflow-ellipsis text-left flex flex-row gap-x-1 font-medium ${
              _ctx.detailData.commissionStatus.toLowerCase() === 'success'
                ? 'text-green-lp-100'
                : _ctx.detailData.commissionStatus.toLowerCase() === 'failed'
                ? 'text-red-lp-750'
                : 'text-yellow-lp-100'
            }`
          
          }, [
            (_ctx.detailData.commissionStatus.toLowerCase() === 'success')
              ? (_openBlock(), _createBlock("img", _hoisted_1))
              : (_ctx.detailData.commissionStatus.toLowerCase() === 'failed')
                ? (_openBlock(), _createBlock("img", _hoisted_2))
                : (_openBlock(), _createBlock("img", _hoisted_3)),
            _createTextVNode(" " + _toDisplayString(_ctx.detailData.commissionStatus), 1)
          ], 2)
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_CreateUpdate, {
        createdAt: _ctx.detailData.commissionCreatedAt,
        createdBy: _ctx.detailData.commissionCreatedBy,
        updatedAt: _ctx.detailData.commissionUpdatedAt,
        updatedBy: _ctx.detailData.commissionUpdatedBy
      }, null, 8, ["createdAt", "createdBy", "updatedAt", "updatedBy"])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}